import { Button, TableCell, styled, Tabs, Tab } from '@mui/material';

export const StyledTabs = styled(Tabs)`
    width: 100%;
    display: flex;
`;

export const StyledTab = styled(Tab)`
    flex-grow: 1;
    text-transform: none;
    font-size: 1rem;
`;

export const ActionsTableCell = styled(TableCell)`
    white-space: nowrap;
    padding: 0.4rem 1rem;
`;

export const StyledTableCell = styled(TableCell)`
    padding: 0 1rem;
    width: 100%;
`;

export const StyledActionButton = styled(Button)`
    white-space: nowrap;
    margin-right: 0.4rem;

    &:last-child {
        margin-right: 0;
    }
`;
